import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton, Link } from "@mui/material";
import React from "react";

import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  adminButtonOutlinedSx,
} from "../../../../../components/AdminDashboard/modalStyle";
import { useAdminStore } from "../../../../../context/admin-store";
import { ModalComponent } from "../../../../../ui-components/Modal";

function parseDate(date: Date) {
  const options: any = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  };
  return new Date(date).toLocaleDateString("pt-BR", options);
}

// Removido estilo fixo para usar estilo responsivo do Admin

interface Expositor {
  name: string;
  email: string;
  created_at: Date;
  is_admin: boolean;
  full_address: string;
  instagram_url: string;
  brand_name: string;
  address: string;
  id: number;
  phone: string;
  brand_description: string;
  state: string;
  city: string;
  overdue: boolean;
}

export default function ViewButton({
  id,
  updateEvents,
  expositor,
}: {
  id: number;
  updateEvents: Function;
  expositor: Expositor;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const bios = useAdminStore((state) => state.bios);
  const [open, setOpen] = React.useState(false);
  const rawInstagram = (expositor.instagram_url || "").toString().trim();
  const instagramHref = rawInstagram
    ? rawInstagram.startsWith("http")
      ? rawInstagram
      : `https://www.instagram.com/${rawInstagram.replace(/^@/, "")}/`
    : "";

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ModalComponent open={open} handleClose={handleClose} title="Informações do Expositor" maxWidth={isMobile ? "92%" : 600} autoHeight>
        <Box>
          <p>
            <strong>ID:</strong> {expositor.id}
          </p>
          <p>
            <strong>Nome:</strong> {expositor.name}
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <Link href={`mailto:${expositor.email}`}> {expositor.email}</Link>
          </p>
          <p>
            <strong>Instagram:</strong>{" "}
            {rawInstagram ? (
              <Link
                target={"_blank"}
                rel={"noopener noreferrer"}
                href={instagramHref}
              >
                {rawInstagram}
              </Link>
            ) : (
              <span>-</span>
            )}
          </p>
          <p>
            <strong>Telefone:</strong> {expositor.phone}{" "}
            {
              <>
                {" "}
                •{" "}
                <Link
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  href={`https://wa.me/${expositor.phone}`}
                >
                  WhatsApp
                </Link>
              </>
            }
          </p>
          <p>
            <strong>Endereço:</strong> {expositor.address}
          </p>
          <p>
            <strong>Estado:</strong> {expositor.state}
          </p>
          <p>
            <strong>Cidade:</strong> {expositor.city}
          </p>

          {bios.length > 0 && (
            <p>
              <strong>Bio:</strong>{" "}
              {bios.find((bio) => bio.user_id === expositor.id)?.bio}
            </p>
          )}

          <p>
            <strong>Nome da Marca:</strong> {expositor.brand_name}
          </p>
          <p>
            <strong>Descrição:</strong> {expositor.brand_description}
          </p>
          <p>
            <strong>Criado em:</strong> {parseDate(expositor.created_at)}
          </p>
        </Box>
        <Box
          sx={{
            p: 3,
            borderTop: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={adminButtonOutlinedSx}
          >
            Fechar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton title="Pressione 2 vezes para ver mais" onClick={handleOpen}>
        <VisibilityIcon />
      </IconButton>
    </>
  );
}
